import React, { useState, useEffect } from 'react'
import translate from '../../reusable/translate'
import Tooltip from '../tooltip/Tooltip'

import { bindActionCreators } from 'redux'
import { useDispatch, useSelector } from 'react-redux'

import validatorSlice from '../../../state/slices/validatorSlice'
import {getCommitmentTypeId} from "../helpers/Categories";

const ValueTypeMeter = ({ meter, changeStartingLevel, changeTargetLevel, changeGraphType, disabled }) => {

    const { commitment } = useSelector((state) => state)


    const [graphType, setGraphType] = useState(meter.meterChartType || 'LINE')
    const [startingLevel, setStartingLevel] = useState(meter.startingLevel || '')
    const [targetLevel, setTargetLevel] = useState( meter.targetLevel || '')

    useEffect(() => {
        changeStartingLevel(startingLevel)
    }, [startingLevel])

    useEffect(() => {
        changeTargetLevel(targetLevel)
    }, [targetLevel])

    useEffect(() => {
        changeGraphType(graphType)
    }, [graphType])

    return(
        <div>
            <div className="flex-row items-center margin-top-bot">
                <div className="w300">
                    <div className="flex-row">
                        <p className="p">{translate({ textKey: 'sit.commitmentCreation.setLevels' })}</p>
                        <Tooltip
                            textKey={`tooltip.setLevels.${commitment.commitmentSubcategoryId}`}
                            secondaryTextKey={`tooltip.setLevels.${commitment.commitmentCategoryId}`}
                            fallback={`tooltip.setLevels.${getCommitmentTypeId(commitment.commitmentType)}`}
                        />
                    </div>
                </div>

                <LevelsContainer
                    startingLevel={startingLevel}
                    setStartingLevel={setStartingLevel}
                    targetLevel={targetLevel}
                    setTargetLevel={setTargetLevel}
                    disabled={disabled}
                />

            </div>

            <SelectChartTypeContainer
                graphType={graphType}
                setGraphType={setGraphType}
            />

        </div>
    )
}

export default ValueTypeMeter

const LevelsContainer = ({ startingLevel, setStartingLevel, targetLevel, setTargetLevel, disabled }) => {

    const { validators } = useSelector((state) => state)
    const dispatch = useDispatch()
    const { changeLevelValidator } = bindActionCreators(validatorSlice.actions, dispatch)

    return(
        <div className="flex-row items-center w500 space-between">
            <input
                className={`input-number ${validators.level ? '' : 'input-number-validated'}`}
                type="number"
                value={startingLevel}
                placeholder={translate({ textKey: 'sit.commitmentCreation.setStartingLevel' })}
                onChange={(e) => {
                    changeLevelValidator(true)
                    setStartingLevel(e.target.value)}}
                disabled={disabled}
            />
            <i className="fas fa-arrow-right"/>
            <input
                className={`input-number ${validators.level ? '' : 'input-number-validated'}`}
                type="number"
                value={targetLevel}
                placeholder={translate({ textKey: 'sit.commitmentCreation.setTargetLevel' })}
                onChange={(e) => {
                    changeLevelValidator(true)
                    setTargetLevel(e.target.value)
                }}
                disabled={disabled}
            />
        </div>
    )
}

const SelectChartTypeContainer = ({ graphType, setGraphType }) => {
    return(
        <div className="flex-row items-center margin-top-bot">

            <div className="w300">
                <div className="flex-row">
                    <p className="p">{translate({ textKey: 'sit.commitmentCreation.chooseGraphType' })}</p>
                    <Tooltip textKey={'tooltip.chooseGraphType'}/>
                </div>
            </div>

            <div className="w500">
                <select
                    className="select"
                    name="graph-type"
                    value={graphType}
                    onChange={(e) => setGraphType(e.target.value)}
                >
                    <option value="LINE">{translate({ textKey: 'sit.statistics.chartTypes.LINE' })}</option>
                    <option value="COLUMN">{translate({ textKey: 'sit.statistics.chartTypes.COLUMN' })}</option>
                    <option value="PIE">{translate({ textKey: 'sit.statistics.chartTypes.PIE' })}</option>
                </select>
            </div>
        </div>
    )
}


// WEBPACK FOOTER //
// ./src/components/materialCommitment/meter/ValueTypeMeter.jsx